import axios from 'axios'
import store from '@/store'
let instance = axios.create();
instance.defaults.baseURL = 'https://hudong.voc.com.cn';

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    if(store.state.hasLogin){
        config.headers['RMT-Auth'] = store.state.userinfo.token
    }
    config.headers['RMT-Request-Time'] = new Date().valueOf()
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    return response
    // 对响应数据做点什么  
}, function (error) {
    // 对响应错误做点什么
    console.log('--- 401 res error response ---')
    console.log(error)
    return Promise.reject(error)
})
export default instance